<a
  class="btn btn-action btn-small back-navigation"
  [routerLink]="{ cxRoute: 'dispenserAgreements' } | cxUrl"
  [queryParams]="sharedService.getQueryParamsLocal('dispenserAgreements')"
  >
  <i class="fas fa-arrow-left mr-1"></i>
  {{ 'shared.backTo.dispensers' | cxTranslate }}
</a>

@if (agreement) {
  <div class="container">
    <div class="card agreement-detail">
      <div class="row card-body agreement-detail-content">
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.agreementNumber' | cxTranslate }}</b>
          <span>{{ agreement.orderCode }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.endCustomerBNFull' | cxTranslate }}</b>
          <span>{{ agreement.endCustomer?.orgUnit?.businessNumber }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.endCustomerNumber' | cxTranslate }}</b>
          <span>{{ agreement.endCustomer?.orgUnit?.uid }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.startDate' | cxTranslate }}</b>
          <span>{{ agreement.startDate | cxDate: 'longDate' }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.endCustomerDescription' | cxTranslate }}</b>
          <span>{{ agreement.endCustomer?.orgUnit?.name }}</span>
        </div>
        <div class="col-12 agreement-detail-actions">
          <button class="btn btn-primary btn-small mt-2" (click)="shipment()">
            {{ 'dispenserAgreement.transactionHistory' | cxTranslate }}
          </button>
          @if (showWhenAccepted) {
            <button class="btn btn-primary btn-small ml-3 mt-2" (click)="placeOrder()">
              {{ 'dispenserAgreement.createOrdersClaims' | cxTranslate }}
            </button>
          }
          <button
            class="btn btn-primary btn-small ml-3 mt-2"
            (click)="downloadCSV(agreement.orderCode)"
            [disabled]="!entries?.results?.length"
            >
            <i class="fa fa-download"></i>
            {{ 'dispenserAgreement.downloadCSV' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (entries?.results?.length) {
  <app-custom-table
    [headers]="headers"
    [columns]="columns"
    rowId="product.code"
    [rows]="entries.results"
    [pagination]="entries.pagination"
    (changePagination)="pageChange($event)"
    [showLoader]="showLoaderOnPagination"
  ></app-custom-table>
} @else {
  @if (!showInitialLoader) {
    @if (!showError404) {
      <app-custom-error [errorMessage]="'shared.noEntries' | cxTranslate"></app-custom-error>
    }
    @if (showError404) {
      <app-custom-error [errorMessage]="'shared.error.notFound404' | cxTranslate"></app-custom-error>
    }
  }
}


@if (showInitialLoader) {
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
}
